// src/hooks/useApi.ts
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';

const useApi = <T = any>(apiFunction: Function, initialParams: any = null) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = useCallback(
    async (params = initialParams) => {
      setLoading(true);
      setError(null);
      try {
        const source = axios.CancelToken.source();
        const result = await apiFunction(params, { cancelToken: source.token });
        setData(result);
        setLoading(false);
        return result;
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log('Request canceled', err.message);
        } else {
          setError(err);
        }
        setLoading(false);
        throw err;
      }
    },
    [apiFunction, initialParams]
  );

  return { data, loading, error, execute };
};

export default useApi;
